document.addEventListener('DOMContentLoaded', function () {
  const singleRadiobtns = document.querySelector('.single_subscription_app input[name="subscription_app"]');
  singleRadiobtns.click(); 
  sessionStorage.setItem('clickedRadio', 'true'); 
});
const hiddenInput = document.querySelector('.selected-selling-plan-id');
const originalValue = hiddenInput ? hiddenInput.value : ''; 
document.querySelectorAll('input[name="subscription_app"]').forEach((input) => {
  input.addEventListener('change', function() {
    const parentDiv = this.closest('div');
    document.querySelectorAll('.main_subscription_app > div').forEach((parent) => {
      parent.classList.remove('checked');
    });
    parentDiv.classList.add('checked');
    if (this.closest('.single_subscription_app') && this.checked) {
      const squantityValue = document.querySelector('.main_quantity__input');
      const sthisValue = this.value;
      // console.log(sthisValue);
      if (squantityValue) {
        squantityValue.value = sthisValue;
        squantityValue.dispatchEvent(new Event('input'));  
      } else {
        console.error("quantity__input element not found.");
      }
      if (hiddenInput) {
        hiddenInput.value = ''; 
      }
    }
    else if (this.closest('.bundle_subscription_app') && this.checked) {
      if (this.checked){
        const defaultCheckedbtn = document.querySelector('.default_bulk_bundle');
        const defaultBundleSave = document.querySelectorAll('.under_bundle_save [name="subscription_bulk_quantity"]');
        let hasActive = false;
        defaultBundleSave.forEach(function(defaultbundle) {
        if (defaultbundle.parentElement.classList.contains('active')){
            hasActive = true;
        }
        });
        if(!hasActive){
            defaultCheckedbtn.click();
         }  
      }
      if (hiddenInput) {
        hiddenInput.value = originalValue; 
      }
    }
  });
});
const buttonNameB = document.querySelector('.product-form__submit span');
const productFormBtn = document.querySelector('.product-form');
const bundleButtonBtn = document.querySelector('.bundle-button-btn');
const originalbuttonNameB = buttonNameB ? buttonNameB.textContent : ''; 
document.querySelectorAll('.single_subscription_app input[name="subscription_app"]').forEach(input => {
    input.addEventListener('click', function() {
        const radioButtons = document.querySelectorAll('input[name="subscription_bulk_quantity"]');
        radioButtons.forEach(radio => {
            radio.checked = false;
            radio.parentElement.classList.remove('active');
        });
        if (buttonNameB) {
        buttonNameB.textContent = originalbuttonNameB; 
      }
     bundleButtonBtn.style.display = 'none';
     productFormBtn.style.display = 'block';
    });
});
document.querySelectorAll('.under_bundle_save [name="subscription_bulk_quantity"]').forEach((input) => {
  input.addEventListener('change', function() {
    const singleRadiobtns = document.querySelectorAll('.single_subscription_app input[name="subscription_app"]');
    const bundleRadiobtns = document.querySelectorAll('.bundle_subscription_app input[name="subscription_app"]');
    const thisValue = input.value;
    const quantityValue = document.querySelector('.main_quantity__input');
    const thisparentClass = document.querySelectorAll('.main_subscription_app .under_bundle_save .under_bundle_save_content p');
    thisparentClass.forEach(function(element) {
      element.classList.remove('active');
    });
      // console.log('without' +quantityValue.value);
    input.parentElement.classList.add('active');
    if (quantityValue) {
      quantityValue.value = thisValue;
      quantityValue.dispatchEvent(new Event('input')); 
      // console.log('with' +quantityValue.value);
    } else {
      console.error("quantity__input element not found.");
    }
    singleRadiobtns.forEach(radio => {
      radio.classList.remove('checked');
      radio.checked = false;
      radio.parentElement.classList.remove('checked');
    });
    bundleRadiobtns.forEach(radio => {
      radio.checked = false;
      radio.parentElement.classList.add('checked');
      radio.click();
    });
      if (buttonNameB) {
        buttonNameB.textContent = 'Bundle Now'; 
      }
    productFormBtn.style.display = 'none';
    bundleButtonBtn.style.display = 'flex';
  });
});

// onclick to redirect bundle page
document.addEventListener("DOMContentLoaded", function() {
    const container = document.querySelector('.under_bundle_save_content');

    if (container) {
      const radios = container.querySelectorAll('input[type="radio"][name="subscription_bulk_quantity"]');

      radios.forEach(function(radio) {
        radio.addEventListener('click', function() {
          const targetUrl = radio.getAttribute('data-url');
          if (targetUrl) {
            window.location.href = targetUrl;
          }
        });
      });
    }
  });